export const radixReferenceColors = {
    grayP3: [
        'color(display-p3 0.988 0.988 0.988)',
        'color(display-p3 0.975 0.975 0.975)',
        'color(display-p3 0.939 0.939 0.939)',
        'color(display-p3 0.908 0.908 0.908)',
        'color(display-p3 0.88 0.88 0.88)',
        'color(display-p3 0.849 0.849 0.849)',
        'color(display-p3 0.807 0.807 0.807)',
        'color(display-p3 0.732 0.732 0.732)',
        'color(display-p3 0.553 0.553 0.553)',
        'color(display-p3 0.512 0.512 0.512)',
        'color(display-p3 0.392 0.392 0.392)',
        'color(display-p3 0.125 0.125 0.125)',
    ],
    grayDarkP3: [
        'color(display-p3 0.067 0.067 0.067)',
        'color(display-p3 0.098 0.098 0.098)',
        'color(display-p3 0.135 0.135 0.135)',
        'color(display-p3 0.163 0.163 0.163)',
        'color(display-p3 0.192 0.192 0.192)',
        'color(display-p3 0.228 0.228 0.228)',
        'color(display-p3 0.283 0.283 0.283)',
        'color(display-p3 0.375 0.375 0.375)',
        'color(display-p3 0.431 0.431 0.431)',
        'color(display-p3 0.484 0.484 0.484)',
        'color(display-p3 0.706 0.706 0.706)',
        'color(display-p3 0.933 0.933 0.933)',
    ],
    mauveP3: [
        'color(display-p3 0.991 0.988 0.992)',
        'color(display-p3 0.98 0.976 0.984)',
        'color(display-p3 0.946 0.938 0.952)',
        'color(display-p3 0.915 0.906 0.925)',
        'color(display-p3 0.886 0.876 0.901)',
        'color(display-p3 0.856 0.846 0.875)',
        'color(display-p3 0.814 0.804 0.84)',
        'color(display-p3 0.735 0.728 0.777)',
        'color(display-p3 0.555 0.549 0.596)',
        'color(display-p3 0.514 0.508 0.552)',
        'color(display-p3 0.395 0.388 0.424)',
        'color(display-p3 0.128 0.122 0.147)',
    ],
    mauveDarkP3: [
        'color(display-p3 0.07 0.067 0.074)',
        'color(display-p3 0.101 0.098 0.105)',
        'color(display-p3 0.138 0.134 0.144)',
        'color(display-p3 0.167 0.161 0.175)',
        'color(display-p3 0.196 0.189 0.206)',
        'color(display-p3 0.232 0.225 0.245)',
        'color(display-p3 0.286 0.277 0.302)',
        'color(display-p3 0.383 0.373 0.408)',
        'color(display-p3 0.434 0.428 0.467)',
        'color(display-p3 0.487 0.48 0.519)',
        'color(display-p3 0.707 0.7 0.735)',
        'color(display-p3 0.933 0.933 0.94)',
    ],
    slateP3: [
        'color(display-p3 0.988 0.988 0.992)',
        'color(display-p3 0.976 0.976 0.984)',
        'color(display-p3 0.94 0.941 0.953)',
        'color(display-p3 0.908 0.909 0.925)',
        'color(display-p3 0.88 0.881 0.901)',
        'color(display-p3 0.85 0.852 0.876)',
        'color(display-p3 0.805 0.808 0.838)',
        'color(display-p3 0.727 0.733 0.773)',
        'color(display-p3 0.547 0.553 0.592)',
        'color(display-p3 0.503 0.512 0.549)',
        'color(display-p3 0.379 0.392 0.421)',
        'color(display-p3 0.113 0.125 0.14)',
    ],
    slateDarkP3: [
        'color(display-p3 0.067 0.067 0.074)',
        'color(display-p3 0.095 0.098 0.105)',
        'color(display-p3 0.13 0.135 0.145)',
        'color(display-p3 0.156 0.163 0.176)',
        'color(display-p3 0.183 0.191 0.206)',
        'color(display-p3 0.215 0.226 0.244)',
        'color(display-p3 0.265 0.28 0.302)',
        'color(display-p3 0.357 0.381 0.409)',
        'color(display-p3 0.415 0.431 0.463)',
        'color(display-p3 0.469 0.483 0.514)',
        'color(display-p3 0.692 0.704 0.728)',
        'color(display-p3 0.93 0.933 0.94)',
    ],
    sageP3: [
        'color(display-p3 0.986 0.992 0.988)',
        'color(display-p3 0.97 0.977 0.974)',
        'color(display-p3 0.935 0.944 0.94)',
        'color(display-p3 0.904 0.913 0.909)',
        'color(display-p3 0.875 0.885 0.88)',
        'color(display-p3 0.844 0.854 0.849)',
        'color(display-p3 0.8 0.811 0.806)',
        'color(display-p3 0.725 0.738 0.732)',
        'color(display-p3 0.531 0.556 0.546)',
        'color(display-p3 0.492 0.515 0.506)',
        'color(display-p3 0.377 0.395 0.389)',
        'color(display-p3 0.107 0.129 0.118)',
    ],
    sageDarkP3: [
        'color(display-p3 0.064 0.07 0.067)',
        'color(display-p3 0.092 0.098 0.094)',
        'color(display-p3 0.128 0.135 0.131)',
        'color(display-p3 0.155 0.164 0.159)',
        'color(display-p3 0.183 0.193 0.188)',
        'color(display-p3 0.218 0.23 0.224)',
        'color(display-p3 0.269 0.285 0.277)',
        'color(display-p3 0.362 0.382 0.373)',
        'color(display-p3 0.398 0.438 0.421)',
        'color(display-p3 0.453 0.49 0.474)',
        'color(display-p3 0.685 0.709 0.697)',
        'color(display-p3 0.927 0.933 0.93)',
    ],
    oliveP3: [
        'color(display-p3 0.989 0.992 0.989)',
        'color(display-p3 0.974 0.98 0.973)',
        'color(display-p3 0.939 0.945 0.937)',
        'color(display-p3 0.907 0.914 0.905)',
        'color(display-p3 0.878 0.885 0.875)',
        'color(display-p3 0.846 0.855 0.843)',
        'color(display-p3 0.803 0.812 0.8)',
        'color(display-p3 0.727 0.738 0.723)',
        'color(display-p3 0.541 0.556 0.532)',
        'color(display-p3 0.5 0.515 0.491)',
        'color(display-p3 0.38 0.395 0.374)',
        'color(display-p3 0.117 0.129 0.111)',
    ],
    oliveDarkP3: [
        'color(display-p3 0.067 0.07 0.063)',
        'color(display-p3 0.095 0.098 0.091)',
        'color(display-p3 0.131 0.135 0.126)',
        'color(display-p3 0.158 0.163 0.153)',
        'color(display-p3 0.186 0.192 0.18)',
        'color(display-p3 0.221 0.229 0.215)',
        'color(display-p3 0.273 0.284 0.266)',
        'color(display-p3 0.365 0.382 0.359)',
        'color(display-p3 0.414 0.438 0.404)',
        'color(display-p3 0.467 0.49 0.458)',
        'color(display-p3 0.69 0.709 0.682)',
        'color(display-p3 0.927 0.933 0.926)',
    ],
    sandP3: [
        'color(display-p3 0.992 0.992 0.989)',
        'color(display-p3 0.977 0.977 0.973)',
        'color(display-p3 0.943 0.942 0.936)',
        'color(display-p3 0.913 0.912 0.903)',
        'color(display-p3 0.885 0.883 0.873)',
        'color(display-p3 0.854 0.852 0.839)',
        'color(display-p3 0.813 0.81 0.794)',
        'color(display-p3 0.738 0.734 0.713)',
        'color(display-p3 0.553 0.553 0.528)',
        'color(display-p3 0.511 0.511 0.488)',
        'color(display-p3 0.388 0.388 0.37)',
        'color(display-p3 0.129 0.126 0.111)',
    ],
    sandDarkP3: [
        'color(display-p3 0.067 0.067 0.063)',
        'color(display-p3 0.098 0.098 0.094)',
        'color(display-p3 0.135 0.135 0.129)',
        'color(display-p3 0.164 0.163 0.156)',
        'color(display-p3 0.193 0.192 0.183)',
        'color(display-p3 0.23 0.229 0.217)',
        'color(display-p3 0.285 0.282 0.267)',
        'color(display-p3 0.384 0.378 0.357)',
        'color(display-p3 0.434 0.428 0.403)',
        'color(display-p3 0.487 0.481 0.456)',
        'color(display-p3 0.707 0.703 0.68)',
        'color(display-p3 0.933 0.933 0.926)',
    ],
    tomatoP3: [
        'color(display-p3 0.998 0.989 0.988)',
        'color(display-p3 0.994 0.974 0.969)',
        'color(display-p3 0.985 0.924 0.909)',
        'color(display-p3 0.996 0.868 0.835)',
        'color(display-p3 0.98 0.812 0.77)',
        'color(display-p3 0.953 0.75 0.698)',
        'color(display-p3 0.917 0.673 0.611)',
        'color(display-p3 0.875 0.575 0.502)',
        'color(display-p3 0.831 0.345 0.231)',
        'color(display-p3 0.802 0.313 0.2)',
        'color(display-p3 0.755 0.259 0.152)',
        'color(display-p3 0.335 0.165 0.132)',
    ],
    tomatoDarkP3: [
        'color(display-p3 0.09 0.068 0.067)',
        'color(display-p3 0.115 0.084 0.076)',
        'color(display-p3 0.205 0.097 0.083)',
        'color(display-p3 0.282 0.099 0.077)',
        'color(display-p3 0.339 0.129 0.101)',
        'color(display-p3 0.398 0.179 0.141)',
        'color(display-p3 0.487 0.245 0.194)',
        'color(display-p3 0.629 0.322 0.248)',
        'color(display-p3 0.831 0.345 0.231)',
        'color(display-p3 0.862 0.415 0.298)',
        'color(display-p3 1 0.585 0.455)',
        'color(display-p3 0.959 0.833 0.802)',
    ],
    redP3: [
        'color(display-p3 0.998 0.989 0.988)',
        'color(display-p3 0.995 0.971 0.971)',
        'color(display-p3 0.985 0.925 0.925)',
        'color(display-p3 0.999 0.866 0.866)',
        'color(display-p3 0.984 0.812 0.811)',
        'color(display-p3 0.955 0.751 0.749)',
        'color(display-p3 0.915 0.675 0.672)',
        'color(display-p3 0.872 0.575 0.572)',
        'color(display-p3 0.83 0.329 0.324)',
        'color(display-p3 0.798 0.294 0.285)',
        'color(display-p3 0.744 0.234 0.222)',
        'color(display-p3 0.36 0.115 0.143)',
    ],
    redDarkP3: [
        'color(display-p3 0.093 0.068 0.067)',
        'color(display-p3 0.118 0.077 0.079)',
        'color(display-p3 0.211 0.081 0.099)',
        'color(display-p3 0.287 0.079 0.113)',
        'color(display-p3 0.348 0.11 0.142)',
        'color(display-p3 0.414 0.16 0.183)',
        'color(display-p3 0.508 0.224 0.236)',
        'color(display-p3 0.659 0.298 0.297)',
        'color(display-p3 0.83 0.329 0.324)',
        'color(display-p3 0.861 0.403 0.387)',
        'color(display-p3 1 0.57 0.55)',
        'color(display-p3 0.971 0.826 0.852)',
    ],
    rubyP3: [
        'color(display-p3 0.998 0.989 0.992)',
        'color(display-p3 0.995 0.971 0.974)',
        'color(display-p3 0.983 0.92 0.928)',
        'color(display-p3 0.987 0.869 0.885)',
        'color(display-p3 0.968 0.817 0.839)',
        'color(display-p3 0.937 0.758 0.786)',
        'color(display-p3 0.897 0.685 0.721)',
        'color(display-p3 0.851 0.588 0.639)',
        'color(display-p3 0.83 0.323 0.408)',
        'color(display-p3 0.795 0.286 0.375)',
        'color(display-p3 0.728 0.211 0.311)',
        'color(display-p3 0.36 0.115 0.171)',
    ],
    rubyDarkP3: [
        'color(display-p3 0.093 0.068 0.074)',
        'color(display-p3 0.113 0.083 0.089)',
        'color(display-p3 0.208 0.088 0.117)',
        'color(display-p3 0.279 0.092 0.147)',
        'color(display-p3 0.337 0.12 0.18)',
        'color(display-p3 0.401 0.166 0.223)',
        'color(display-p3 0.495 0.224 0.281)',
        'color(display-p3 0.652 0.295 0.359)',
        'color(display-p3 0.83 0.323 0.408)',
        'color(display-p3 0.857 0.392 0.455)',
        'color(display-p3 1 0.57 0.59)',
        'color(display-p3 0.968 0.83 0.88)',
    ],
    crimsonP3: [
        'color(display-p3 0.998 0.989 0.992)',
        'color(display-p3 0.991 0.969 0.976)',
        'color(display-p3 0.987 0.917 0.941)',
        'color(display-p3 0.975 0.866 0.904)',
        'color(display-p3 0.953 0.813 0.864)',
        'color(display-p3 0.921 0.755 0.817)',
        'color(display-p3 0.88 0.683 0.761)',
        'color(display-p3 0.834 0.592 0.694)',
        'color(display-p3 0.843 0.298 0.507)',
        'color(display-p3 0.807 0.266 0.468)',
        'color(display-p3 0.731 0.195 0.388)',
        'color(display-p3 0.352 0.111 0.221)',
    ],
    crimsonDarkP3: [
        'color(display-p3 0.093 0.068 0.078)',
        'color(display-p3 0.117 0.078 0.095)',
        'color(display-p3 0.203 0.091 0.143)',
        'color(display-p3 0.277 0.087 0.182)',
        'color(display-p3 0.332 0.115 0.22)',
        'color(display-p3 0.394 0.162 0.268)',
        'color(display-p3 0.489 0.222 0.336)',
        'color(display-p3 0.638 0.289 0.429)',
        'color(display-p3 0.843 0.298 0.507)',
        'color(display-p3 0.864 0.364 0.539)',
        'color(display-p3 1 0.56 0.66)',
        'color(display-p3 0.966 0.834 0.906)',
    ],
    pinkP3: [
        'color(display-p3 0.998 0.989 0.996)',
        'color(display-p3 0.992 0.97 0.985)',
        'color(display-p3 0.981 0.917 0.96)',
        'color(display-p3 0.963 0.867 0.932)',
        'color(display-p3 0.939 0.815 0.899)',
        'color(display-p3 0.907 0.756 0.859)',
        'color(display-p3 0.869 0.683 0.81)',
        'color(display-p3 0.825 0.59 0.751)',
        'color(display-p3 0.775 0.297 0.61)',
        'color(display-p3 0.748 0.27 0.581)',
        'color(display-p3 0.698 0.219 0.528)',
        'color(display-p3 0.363 0.101 0.279)',
    ],
    pinkDarkP3: [
        'color(display-p3 0.093 0.068 0.089)',
        'color(display-p3 0.121 0.073 0.11)',
        'color(display-p3 0.198 0.098 0.179)',
        'color(display-p3 0.271 0.095 0.231)',
        'color(display-p3 0.32 0.127 0.273)',
        'color(display-p3 0.382 0.177 0.326)',
        'color(display-p3 0.477 0.238 0.405)',
        'color(display-p3 0.612 0.304 0.51)',
        'color(display-p3 0.775 0.297 0.61)',
        'color(display-p3 0.808 0.356 0.645)',
        'color(display-p3 1 0.535 0.78)',
        'color(display-p3 0.964 0.826 0.912)',
    ],
    plumP3: [
        'color(display-p3 0.995 0.988 0.999)',
        'color(display-p3 0.988 0.971 0.99)',
        'color(display-p3 0.973 0.923 0.98)',
        'color(display-p3 0.953 0.875 0.966)',
        'color(display-p3 0.926 0.825 0.945)',
        'color(display-p3 0.89 0.765 0.916)',
        'color(display-p3 0.84 0.686 0.877)',
        'color(display-p3 0.775 0.58 0.832)',
        'color(display-p3 0.624 0.313 0.708)',
        'color(display-p3 0.587 0.29 0.667)',
        'color(display-p3 0.543 0.263 0.619)',
        'color(display-p3 0.299 0.114 0.352)',
    ],
    plumDarkP3: [
        'color(display-p3 0.09 0.068 0.092)',
        'color(display-p3 0.118 0.077 0.121)',
        'color(display-p3 0.192 0.105 0.202)',
        'color(display-p3 0.25 0.121 0.271)',
        'color(display-p3 0.293 0.152 0.319)',
        'color(display-p3 0.343 0.198 0.372)',
        'color(display-p3 0.424 0.262 0.461)',
        'color(display-p3 0.54 0.341 0.595)',
        'color(display-p3 0.624 0.313 0.708)',
        'color(display-p3 0.666 0.365 0.748)',
        'color(display-p3 0.86 0.602 0.933)',
        'color(display-p3 0.936 0.836 0.949)',
    ],
    purpleP3: [
        'color(display-p3 0.995 0.988 0.996)',
        'color(display-p3 0.983 0.971 0.993)',
        'color(display-p3 0.963 0.931 0.989)',
        'color(display-p3 0.937 0.888 0.981)',
        'color(display-p3 0.904 0.837 0.966)',
        'color(display-p3 0.86 0.774 0.942)',
        'color(display-p3 0.799 0.69 0.91)',
        'color(display-p3 0.719 0.583 0.874)',
        'color(display-p3 0.523 0.318 0.751)',
        'color(display-p3 0.483 0.289 0.7)',
        'color(display-p3 0.473 0.281 0.687)',
        'color(display-p3 0.234 0.132 0.363)',
    ],
    purpleDarkP3: [
        'color(display-p3 0.09 0.068 0.103)',
        'color(display-p3 0.113 0.082 0.134)',
        'color(display-p3 0.175 0.112 0.224)',
        'color(display-p3 0.224 0.137 0.297)',
        'color(display-p3 0.264 0.167 0.349)',
        'color(display-p3 0.311 0.208 0.406)',
        'color(display-p3 0.381 0.266 0.496)',
        'color(display-p3 0.49 0.349 0.649)',
        'color(display-p3 0.523 0.318 0.751)',
        'color(display-p3 0.57 0.373 0.791)',
        'color(display-p3 0.8 0.62 1)',
        'color(display-p3 0.913 0.854 0.971)',
    ],
    violetP3: [
        'color(display-p3 0.991 0.988 0.995)',
        'color(display-p3 0.978 0.974 0.998)',
        'color(display-p3 0.953 0.943 0.993)',
        'color(display-p3 0.916 0.897 1)',
        'color(display-p3 0.876 0.851 1)',
        'color(display-p3 0.825 0.793 0.981)',
        'color(display-p3 0.752 0.712 0.943)',
        'color(display-p3 0.654 0.602 0.902)',
        'color(display-p3 0.417 0.341 0.784)',
        'color(display-p3 0.381 0.306 0.741)',
        'color(display-p3 0.383 0.317 0.702)',
        'color(display-p3 0.179 0.15 0.359)',
    ],
    violetDarkP3: [
        'color(display-p3 0.077 0.071 0.118)',
        'color(display-p3 0.101 0.084 0.141)',
        'color(display-p3 0.154 0.123 0.256)',
        'color(display-p3 0.191 0.148 0.345)',
        'color(display-p3 0.226 0.182 0.396)',
        'color(display-p3 0.269 0.223 0.449)',
        'color(display-p3 0.326 0.277 0.53)',
        'color(display-p3 0.399 0.346 0.656)',
        'color(display-p3 0.417 0.341 0.784)',
        'color(display-p3 0.477 0.402 0.823)',
        'color(display-p3 0.72 0.65 1)',
        'color(display-p3 0.883 0.867 0.986)',
    ],
    irisP3: [
        'color(display-p3 0.992 0.992 0.999)',
        'color(display-p3 0.972 0.973 0.998)',
        'color(display-p3 0.943 0.945 0.992)',
        'color(display-p3 0.902 0.906 1)',
        'color(display-p3 0.857 0.861 1)',
        'color(display-p3 0.799 0.805 0.987)',
        'color(display-p3 0.721 0.727 0.955)',
        'color(display-p3 0.61 0.619 0.918)',
        'color(display-p3 0.357 0.357 0.81)',
        'color(display-p3 0.318 0.318 0.774)',
        'color(display-p3 0.337 0.326 0.748)',
        'color(display-p3 0.154 0.161 0.371)',
    ],
    irisDarkP3: [
        'color(display-p3 0.075 0.075 0.114)',
        'color(display-p3 0.089 0.086 0.14)',
        'color(display-p3 0.128 0.134 0.272)',
        'color(display-p3 0.153 0.165 0.382)',
        'color(display-p3 0.192 0.201 0.44)',
        'color(display-p3 0.239 0.241 0.491)',
        'color(display-p3 0.291 0.289 0.565)',
        'color(display-p3 0.35 0.345 0.673)',
        'color(display-p3 0.357 0.357 0.81)',
        'color(display-p3 0.428 0.416 0.843)',
        'color(display-p3 0.685 0.662 1)',
        'color(display-p3 0.878 0.875 0.986)',
    ],
    indigoP3: [
        'color(display-p3 0.992 0.992 0.996)',
        'color(display-p3 0.971 0.977 0.998)',
        'color(display-p3 0.933 0.948 0.992)',
        'color(display-p3 0.885 0.914 1)',
        'color(display-p3 0.831 0.87 1)',
        'color(display-p3 0.767 0.814 0.995)',
        'color(display-p3 0.685 0.74 0.957)',
        'color(display-p3 0.569 0.639 0.916)',
        'color(display-p3 0.276 0.384 0.837)',
        'color(display-p3 0.234 0.343 0.801)',
        'color(display-p3 0.256 0.354 0.755)',
        'color(display-p3 0.133 0.175 0.348)',
    ],
    indigoDarkP3: [
        'color(display-p3 0.068 0.074 0.118)',
        'color(display-p3 0.081 0.089 0.144)',
        'color(display-p3 0.105 0.141 0.275)',
        'color(display-p3 0.129 0.18 0.369)',
        'color(display-p3 0.163 0.22 0.439)',
        'color(display-p3 0.203 0.262 0.5)',
        'color(display-p3 0.245 0.309 0.575)',
        'color(display-p3 0.285 0.362 0.674)',
        'color(display-p3 0.276 0.384 0.837)',
        'color(display-p3 0.354 0.445 0.866)',
        'color(display-p3 0.63 0.69 1)',
        'color(display-p3 0.848 0.881 0.99)',
    ],
    blueP3: [
        'color(display-p3 0.986 0.992 0.999)',
        'color(display-p3 0.96 0.979 0.998)',
        'color(display-p3 0.912 0.956 0.991)',
        'color(display-p3 0.853 0.932 1)',
        'color(display-p3 0.788 0.894 0.998)',
        'color(display-p3 0.709 0.843 0.976)',
        'color(display-p3 0.606 0.777 0.947)',
        'color(display-p3 0.451 0.688 0.917)',
        'color(display-p3 0.247 0.556 0.969)',
        'color(display-p3 0.234 0.523 0.912)',
        'color(display-p3 0.15 0.44 0.84)',
        'color(display-p3 0.102 0.193 0.379)',
    ],
    blueDarkP3: [
        'color(display-p3 0.057 0.081 0.122)',
        'color(display-p3 0.072 0.098 0.147)',
        'color(display-p3 0.078 0.154 0.27)',
        'color(display-p3 0.033 0.197 0.37)',
        'color(display-p3 0.08 0.245 0.441)',
        'color(display-p3 0.14 0.298 0.511)',
        'color(display-p3 0.195 0.361 0.6)',
        'color(display-p3 0.239 0.434 0.72)',
        'color(display-p3 0.247 0.556 0.969)',
        'color(display-p3 0.344 0.612 0.973)',
        'color(display-p3 0.49 0.72 1)',
        'color(display-p3 0.788 0.898 0.99)',
    ],
    cyanP3: [
        'color(display-p3 0.982 0.992 0.996)',
        'color(display-p3 0.955 0.981 0.984)',
        'color(display-p3 0.888 0.965 0.975)',
        'color(display-p3 0.821 0.941 0.959)',
        'color(display-p3 0.751 0.907 0.935)',
        'color(display-p3 0.671 0.862 0.9)',
        'color(display-p3 0.564 0.8 0.854)',
        'color(display-p3 0.388 0.715 0.798)',
        'color(display-p3 0.282 0.627 0.765)',
        'color(display-p3 0.264 0.583 0.71)',
        'color(display-p3 0.08 0.48 0.63)',
        'color(display-p3 0.108 0.232 0.277)',
    ],
    cyanDarkP3: [
        'color(display-p3 0.053 0.085 0.098)',
        'color(display-p3 0.072 0.105 0.122)',
        'color(display-p3 0.073 0.168 0.209)',
        'color(display-p3 0.063 0.216 0.277)',
        'color(display-p3 0.091 0.267 0.336)',
        'color(display-p3 0.137 0.324 0.4)',
        'color(display-p3 0.186 0.398 0.484)',
        'color(display-p3 0.23 0.496 0.6)',
        'color(display-p3 0.282 0.627 0.765)',
        'color(display-p3 0.331 0.675 0.801)',
        'color(display-p3 0.446 0.79 0.887)',
        'color(display-p3 0.757 0.919 0.962)',
    ],
    tealP3: [
        'color(display-p3 0.983 0.996 0.992)',
        'color(display-p3 0.958 0.983 0.976)',
        'color(display-p3 0.895 0.971 0.952)',
        'color(display-p3 0.831 0.949 0.92)',
        'color(display-p3 0.761 0.914 0.878)',
        'color(display-p3 0.682 0.864 0.825)',
        'color(display-p3 0.581 0.798 0.756)',
        'color(display-p3 0.433 0.716 0.671)',
        'color(display-p3 0.297 0.637 0.581)',
        'color(display-p3 0.275 0.599 0.542)',
        'color(display-p3 0.08 0.5 0.43)',
        'color(display-p3 0.11 0.235 0.219)',
    ],
    tealDarkP3: [
        'color(display-p3 0.059 0.083 0.079)',
        'color(display-p3 0.075 0.11 0.107)',
        'color(display-p3 0.087 0.175 0.165)',
        'color(display-p3 0.087 0.227 0.214)',
        'color(display-p3 0.12 0.277 0.261)',
        'color(display-p3 0.162 0.335 0.314)',
        'color(display-p3 0.205 0.406 0.379)',
        'color(display-p3 0.245 0.489 0.453)',
        'color(display-p3 0.297 0.637 0.581)',
        'color(display-p3 0.319 0.69 0.62)',
        'color(display-p3 0.388 0.835 0.719)',
        'color(display-p3 0.734 0.934 0.87)',
    ],
    jadeP3: [
        'color(display-p3 0.986 0.996 0.992)',
        'color(display-p3 0.962 0.983 0.969)',
        'color(display-p3 0.912 0.965 0.932)',
        'color(display-p3 0.858 0.941 0.893)',
        'color(display-p3 0.795 0.909 0.847)',
        'color(display-p3 0.715 0.864 0.791)',
        'color(display-p3 0.603 0.802 0.718)',
        'color(display-p3 0.44 0.72 0.629)',
        'color(display-p3 0.319 0.63 0.521)',
        'color(display-p3 0.299 0.592 0.488)',
        'color(display-p3 0.15 0.5 0.37)',
        'color(display-p3 0.142 0.229 0.194)',
    ],
    jadeDarkP3: [
        'color(display-p3 0.059 0.083 0.071)',
        'color(display-p3 0.078 0.11 0.094)',
        'color(display-p3 0.091 0.176 0.138)',
        'color(display-p3 0.102 0.228 0.177)',
        'color(display-p3 0.133 0.279 0.221)',
        'color(display-p3 0.174 0.334 0.273)',
        'color(display-p3 0.219 0.402 0.335)',
        'color(display-p3 0.263 0.488 0.411)',
        'color(display-p3 0.319 0.63 0.521)',
        'color(display-p3 0.338 0.68 0.555)',
        'color(display-p3 0.4 0.835 0.656)',
        'color(display-p3 0.734 0.934 0.838)',
    ],
    greenP3: [
        'color(display-p3 0.986 0.996 0.989)',
        'color(display-p3 0.963 0.983 0.967)',
        'color(display-p3 0.913 0.964 0.925)',
        'color(display-p3 0.859 0.94 0.879)',
        'color(display-p3 0.796 0.907 0.826)',
        'color(display-p3 0.718 0.863 0.761)',
        'color(display-p3 0.61 0.801 0.675)',
        'color(display-p3 0.451 0.715 0.559)',
        'color(display-p3 0.332 0.634 0.442)',
        'color(display-p3 0.308 0.595 0.417)',
        'color(display-p3 0.19 0.5 0.32)',
        'color(display-p3 0.132 0.228 0.18)',
    ],
    greenDarkP3: [
        'color(display-p3 0.062 0.083 0.071)',
        'color(display-p3 0.079 0.106 0.09)',
        'color(display-p3 0.1 0.173 0.133)',
        'color(display-p3 0.115 0.229 0.166)',
        'color(display-p3 0.147 0.282 0.206)',
        'color(display-p3 0.185 0.338 0.25)',
        'color(display-p3 0.227 0.403 0.298)',
        'color(display-p3 0.27 0.479 0.351)',
        'color(display-p3 0.332 0.634 0.442)',
        'color(display-p3 0.357 0.682 0.474)',
        'color(display-p3 0.434 0.828 0.573)',
        'color(display-p3 0.747 0.938 0.807)',
    ],
    grassP3: [
        'color(display-p3 0.986 0.996 0.985)',
        'color(display-p3 0.966 0.983 0.964)',
        'color(display-p3 0.923 0.965 0.917)',
        'color(display-p3 0.872 0.94 0.865)',
        'color(display-p3 0.811 0.908 0.802)',
        'color(display-p3 0.733 0.864 0.724)',
        'color(display-p3 0.628 0.803 0.622)',
        'color(display-p3 0.477 0.72 0.482)',
        'color(display-p3 0.38 0.647 0.378)',
        'color(display-p3 0.344 0.598 0.342)',
        'color(display-p3 0.263 0.488 0.261)',
        'color(display-p3 0.151 0.233 0.153)',
    ],
    grassDarkP3: [
        'color(display-p3 0.062 0.083 0.067)',
        'color(display-p3 0.083 0.103 0.085)',
        'color(display-p3 0.118 0.163 0.122)',
        'color(display-p3 0.142 0.225 0.15)',
        'color(display-p3 0.178 0.279 0.186)',
        'color(display-p3 0.217 0.337 0.224)',
        'color(display-p3 0.258 0.4 0.264)',
        'color(display-p3 0.302 0.47 0.305)',
        'color(display-p3 0.38 0.647 0.378)',
        'color(display-p3 0.426 0.694 0.426)',
        'color(display-p3 0.535 0.807 0.542)',
        'color(display-p3 0.797 0.936 0.776)',
    ],
    brownP3: [
        'color(display-p3 0.995 0.992 0.989)',
        'color(display-p3 0.987 0.976 0.964)',
        'color(display-p3 0.959 0.936 0.909)',
        'color(display-p3 0.934 0.897 0.855)',
        'color(display-p3 0.909 0.856 0.798)',
        'color(display-p3 0.88 0.808 0.73)',
        'color(display-p3 0.841 0.742 0.639)',
        'color(display-p3 0.782 0.647 0.514)',
        'color(display-p3 0.651 0.505 0.368)',
        'color(display-p3 0.601 0.465 0.344)',
        'color(display-p3 0.485 0.374 0.288)',
        'color(display-p3 0.236 0.202 0.183)',
    ],
    brownDarkP3: [
        'color(display-p3 0.071 0.067 0.059)',
        'color(display-p3 0.107 0.095 0.087)',
        'color(display-p3 0.151 0.13 0.115)',
        'color(display-p3 0.191 0.161 0.138)',
        'color(display-p3 0.235 0.194 0.162)',
        'color(display-p3 0.291 0.237 0.192)',
        'color(display-p3 0.365 0.295 0.232)',
        'color(display-p3 0.469 0.377 0.287)',
        'color(display-p3 0.651 0.505 0.368)',
        'color(display-p3 0.697 0.557 0.423)',
        'color(display-p3 0.835 0.715 0.597)',
        'color(display-p3 0.938 0.885 0.802)',
    ],
    orangeP3: [
        'color(display-p3 0.995 0.988 0.985)',
        'color(display-p3 0.994 0.968 0.934)',
        'color(display-p3 0.989 0.938 0.85)',
        'color(display-p3 1 0.874 0.687)',
        'color(display-p3 1 0.821 0.583)',
        'color(display-p3 0.975 0.767 0.545)',
        'color(display-p3 0.919 0.693 0.486)',
        'color(display-p3 0.877 0.597 0.379)',
        'color(display-p3 0.9 0.45 0.2)',
        'color(display-p3 0.87 0.409 0.164)',
        'color(display-p3 0.76 0.34 0)',
        'color(display-p3 0.323 0.185 0.127)',
    ],
    orangeDarkP3: [
        'color(display-p3 0.088 0.07 0.057)',
        'color(display-p3 0.113 0.089 0.061)',
        'color(display-p3 0.189 0.12 0.056)',
        'color(display-p3 0.262 0.132 0)',
        'color(display-p3 0.315 0.168 0.016)',
        'color(display-p3 0.376 0.219 0.088)',
        'color(display-p3 0.465 0.283 0.147)',
        'color(display-p3 0.601 0.359 0.201)',
        'color(display-p3 0.9 0.45 0.2)',
        'color(display-p3 0.98 0.51 0.23)',
        'color(display-p3 1 0.63 0.38)',
        'color(display-p3 0.98 0.883 0.775)',
    ],
    skyP3: [
        'color(display-p3 0.98 0.995 0.999)',
        'color(display-p3 0.953 0.98 0.99)',
        'color(display-p3 0.899 0.963 0.989)',
        'color(display-p3 0.842 0.937 0.977)',
        'color(display-p3 0.777 0.9 0.954)',
        'color(display-p3 0.701 0.851 0.921)',
        'color(display-p3 0.604 0.785 0.879)',
        'color(display-p3 0.457 0.696 0.829)',
        'color(display-p3 0.585 0.877 0.983)',
        'color(display-p3 0.555 0.845 0.959)',
        'color(display-p3 0.193 0.448 0.605)',
        'color(display-p3 0.145 0.241 0.329)',
    ],
    skyDarkP3: [
        'color(display-p3 0.056 0.078 0.116)',
        'color(display-p3 0.075 0.101 0.149)',
        'color(display-p3 0.089 0.154 0.244)',
        'color(display-p3 0.106 0.207 0.323)',
        'color(display-p3 0.135 0.261 0.394)',
        'color(display-p3 0.17 0.322 0.469)',
        'color(display-p3 0.205 0.394 0.557)',
        'color(display-p3 0.232 0.48 0.665)',
        'color(display-p3 0.585 0.877 0.983)',
        'color(display-p3 0.718 0.925 0.991)',
        'color(display-p3 0.536 0.772 0.924)',
        'color(display-p3 0.799 0.947 0.993)',
    ],
    mintP3: [
        'color(display-p3 0.98 0.995 0.992)',
        'color(display-p3 0.957 0.985 0.977)',
        'color(display-p3 0.888 0.972 0.95)',
        'color(display-p3 0.819 0.951 0.916)',
        'color(display-p3 0.747 0.918 0.873)',
        'color(display-p3 0.668 0.87 0.818)',
        'color(display-p3 0.567 0.805 0.744)',
        'color(display-p3 0.42 0.724 0.649)',
        'color(display-p3 0.62 0.908 0.834)',
        'color(display-p3 0.585 0.871 0.797)',
        'color(display-p3 0.203 0.463 0.397)',
        'color(display-p3 0.136 0.259 0.236)',
    ],
    mintDarkP3: [
        'color(display-p3 0.059 0.082 0.081)',
        'color(display-p3 0.068 0.104 0.105)',
        'color(display-p3 0.077 0.17 0.168)',
        'color(display-p3 0.068 0.224 0.22)',
        'color(display-p3 0.104 0.275 0.264)',
        'color(display-p3 0.154 0.332 0.313)',
        'color(display-p3 0.207 0.403 0.373)',
        'color(display-p3 0.258 0.49 0.441)',
        'color(display-p3 0.62 0.908 0.834)',
        'color(display-p3 0.725 0.954 0.898)',
        'color(display-p3 0.482 0.825 0.733)',
        'color(display-p3 0.807 0.955 0.887)',
    ],
    limeP3: [
        'color(display-p3 0.989 0.992 0.981)',
        'color(display-p3 0.975 0.98 0.954)',
        'color(display-p3 0.939 0.965 0.851)',
        'color(display-p3 0.896 0.94 0.76)',
        'color(display-p3 0.843 0.903 0.678)',
        'color(display-p3 0.778 0.852 0.599)',
        'color(display-p3 0.694 0.784 0.508)',
        'color(display-p3 0.585 0.707 0.378)',
        'color(display-p3 0.78 0.928 0.466)',
        'color(display-p3 0.734 0.896 0.397)',
        'color(display-p3 0.386 0.482 0.227)',
        'color(display-p3 0.222 0.25 0.128)',
    ],
    limeDarkP3: [
        'color(display-p3 0.067 0.073 0.048)',
        'color(display-p3 0.086 0.1 0.067)',
        'color(display-p3 0.13 0.16 0.099)',
        'color(display-p3 0.172 0.214 0.126)',
        'color(display-p3 0.213 0.266 0.153)',
        'color(display-p3 0.257 0.321 0.182)',
        'color(display-p3 0.307 0.383 0.215)',
        'color(display-p3 0.365 0.456 0.25)',
        'color(display-p3 0.78 0.928 0.466)',
        'color(display-p3 0.865 0.995 0.519)',
        'color(display-p3 0.771 0.893 0.485)',
        'color(display-p3 0.905 0.966 0.753)',
    ],
    yellowP3: [
        'color(display-p3 0.992 0.992 0.978)',
        'color(display-p3 0.995 0.99 0.922)',
        'color(display-p3 0.997 0.982 0.749)',
        'color(display-p3 0.992 0.953 0.627)',
        'color(display-p3 0.984 0.91 0.51)',
        'color(display-p3 0.934 0.847 0.474)',
        'color(display-p3 0.876 0.785 0.46)',
        'color(display-p3 0.811 0.689 0.313)',
        'color(display-p3 1 0.92 0.22)',
        'color(display-p3 0.977 0.868 0.291)',
        'color(display-p3 0.6 0.44 0)',
        'color(display-p3 0.271 0.233 0.137)',
    ],
    yellowDarkP3: [
        'color(display-p3 0.078 0.069 0.047)',
        'color(display-p3 0.103 0.094 0.063)',
        'color(display-p3 0.168 0.137 0.039)',
        'color(display-p3 0.209 0.169 0)',
        'color(display-p3 0.255 0.209 0)',
        'color(display-p3 0.31 0.261 0.07)',
        'color(display-p3 0.389 0.331 0.135)',
        'color(display-p3 0.497 0.42 0.182)',
        'color(display-p3 1 0.92 0.22)',
        'color(display-p3 1 1 0.456)',
        'color(display-p3 0.948 0.885 0.392)',
        'color(display-p3 0.959 0.934 0.731)',
    ],
    amberP3: [
        'color(display-p3 0.995 0.992 0.985)',
        'color(display-p3 0.994 0.986 0.921)',
        'color(display-p3 0.994 0.969 0.782)',
        'color(display-p3 0.989 0.937 0.65)',
        'color(display-p3 0.97 0.902 0.527)',
        'color(display-p3 0.936 0.844 0.506)',
        'color(display-p3 0.89 0.762 0.443)',
        'color(display-p3 0.85 0.65 0.3)',
        'color(display-p3 1 0.77 0.26)',
        'color(display-p3 0.959 0.741 0.274)',
        'color(display-p3 0.64 0.4 0)',
        'color(display-p3 0.294 0.208 0.145)',
    ],
    amberDarkP3: [
        'color(display-p3 0.082 0.07 0.05)',
        'color(display-p3 0.111 0.094 0.064)',
        'color(display-p3 0.178 0.128 0.049)',
        'color(display-p3 0.239 0.156 0)',
        'color(display-p3 0.29 0.193 0)',
        'color(display-p3 0.344 0.245 0.076)',
        'color(display-p3 0.422 0.314 0.141)',
        'color(display-p3 0.535 0.399 0.189)',
        'color(display-p3 1 0.77 0.26)',
        'color(display-p3 1 0.87 0.15)',
        'color(display-p3 1 0.8 0.29)',
        'color(display-p3 0.984 0.909 0.726)',
    ],
};
//# sourceMappingURL=radixReferenceColors.js.map